import _ from 'lodash'

import {
  getCourses,
  getStudents,
  getHomeworks,
  getRatings,
  reviewHomework,
  getWebinars,
  createWebinar,
  updateWebinar,
  getCommissions,
  getCommissionStatistics
} from '@/api/data'

const state = {
  course: null,
  students: [],
  courses: null,
  homeworks: [],
  ratings: null,
  webinars: [],
  commissions: null,
  commissionsPaginate: null,
  commissionStatistics: null
}

const mutations = {
  SET_COURSE: (state, course) => {
    state.course = course
  },

  SET_COURSES: (state, courses) => {
    state.courses = courses
  },

  SET_STUDENTS: (state, students) => {
    state.students = students
  },

  SET_HOMEWORKS: (state, homeworks) => {
    state.homeworks = homeworks
  },

  SET_HOMEWORK: (state, data) => {
    state.homeworks.splice(data.index, 1, data.homework)
  },

  SET_RATINGS: (state, ratings) => {
    state.ratings = ratings
  },

  SET_WEBINARS: (state, webinars) => {
    state.webinars = webinars
  },

  CREATE_WEBINAR: (state, webinar) => {
    state.webinars.unshift(webinar)
  },

  UPDATE_WEBINAR: (state, webinar) => {
    const index = _.findIndex(state.webinars, (element) => {
      return element._id.toString() === webinar._id.toString()
    })
    state.webinars.splice(index, 1, webinar)
  },

  SET_COMMISSIONS: (state, commissions) => {
    state.commissions = commissions
  },

  SET_COMMISSIONS_PAGINATE: (state, headers) => {
    state.commissionsPaginate = {
      page: parseInt(headers['x-pagination-page']),
      limit: parseInt(headers['x-pagination-limit']),
      total: parseInt(headers['x-pagination-total'])
    }
  },

  SET_COMMISSION_STATISTICS: (state, statistics) => {
    state.commissionStatistics = statistics
  }
}

const actions = {
  GetCourses({ commit }, query) {
    return new Promise((resolve, reject) => {
      getCourses(query).then(response => {
        commit('SET_COURSES', response.data.courses)
        resolve(response.data.courses)
      }).catch(reject)
    })
  },

  SetCourse({ commit }, course) {
    commit('SET_COURSE', course)
  },

  GetStudents({ commit }, query) {
    return new Promise((resolve, reject) => {
      getStudents(query).then(response => {
        commit('SET_STUDENTS', response.data.students)
        resolve(response.data.students)
      }).catch(reject)
    })
  },

  SetStudents({ commit }, data) {
    commit('SET_STUDENTS', data)
  },

  GetHomeworks({ commit }, query) {
    return new Promise((resolve, reject) => {
      getHomeworks(query).then(response => {
        commit('SET_HOMEWORKS', response.data.homeworks)
        resolve(response.data.homeworks)
      }).catch(reject)
    })
  },

  SetHomeworks({ commit }, data) {
    commit('SET_HOMEWORKS', data)
  },

  ReviewHomework({ commit }, data) {
    return new Promise((resolve, reject) => {
      reviewHomework({
        query: {
          course_id: data.homework.course_id,
          homework_id: data.homework._id
        },
        body: {
          points: data.homework.points,
          teacher_comment: data.homework.teacher_comment
        }
      }).then(response => {
        commit('SET_HOMEWORK', data)
        resolve(response.data)
      }).catch(reject)
    })
  },

  GetRatings({ commit }, query) {
    return new Promise((resolve, reject) => {
      getRatings(query).then(response => {
        commit('SET_RATINGS', {
          list: response.data.ratings,
          page: parseInt(response.headers['x-pagination-page']),
          limit: parseInt(response.headers['x-pagination-limit']),
          total: parseInt(response.headers['x-pagination-total'])
        })
        resolve()
      }).catch(reject)
    })
  },

  GetWebinars({ commit }, query) {
    return new Promise((resolve, reject) => {
      getWebinars(query).then(response => {
        commit('SET_WEBINARS', response.data.webinars)
        resolve()
      }).catch(reject)
    })
  },

  CreateWebinar({ commit }, data) {
    return new Promise((resolve, reject) => {
      createWebinar(data).then(response => {
        commit('CREATE_WEBINAR', response.data.webinar)
        resolve()
      }).catch(reject)
    })
  },

  UpdateWebinar({ commit }, data) {
    return new Promise((resolve, reject) => {
      updateWebinar(data).then(response => {
        commit('UPDATE_WEBINAR', data)
        resolve()
      }).catch(reject)
    })
  },

  GetCommissions({ commit }, query) {
    return new Promise((resolve, reject) => {
      getCommissions(query).then(response => {
        commit('SET_COMMISSIONS', response.data.commissions)
        commit('SET_COMMISSIONS_PAGINATE', response.headers)
        resolve()
      }).catch(reject)
    })
  },

  GetCommissionStatistics({ commit }, query) {
    return new Promise((resolve, reject) => {
      getCommissionStatistics(query).then(response => {
        commit('SET_COMMISSION_STATISTICS', response.data)
        resolve()
      }).catch(reject)
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
